import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import history from '../../../utils/history';

import Button from '../../common/Button';
import Modal from '../../common/Modal';
import { PRODUCT_FEEDS_SET_DIALOG } from '../../../store/reducers/productsFeeds';

import styles from './GotoProductFeedsModal.module.scss';
import PropTypes from 'prop-types';

export function GotoProductFeedsModal({ content }) {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.productsFeeds.dialog.gotoProductFeedsModal);
  const { supplierId } = useSelector((state) => state.role);

  const closeDialog = () => {
    dispatch({ type: PRODUCT_FEEDS_SET_DIALOG, payload: { gotoProductFeedsModal: false } });
  };

  useEffect(() => {
    return () => closeDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal open={isOpen} onClose={closeDialog} showCloseIcon center>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          {content}
          <button onClick={() => history.push(`/suppliers/${supplierId}/products/feeds`)}>Product Feeds page</button>
        </div>
        <div className={styles.footer}>
          <div className={styles.buttons}>
            <Button text="OK" onClick={closeDialog} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

GotoProductFeedsModal.propTypes = {
  content: PropTypes.node.isRequired,
};
